import React from "react";
import { Checkbox } from "alurkerja-ui";
import { FormField, IFormField } from "./FormField";

interface CheckBoxFieldProps extends IFormField {
  options?: ICheckBoxOption[];
  defaultValue?: string[];
  value?: string;
  onChange?: (value: (string | number)[] | null) => void;
}
export type ICheckBoxOption = { value: string; label: string };

export const CheckBoxField: React.FC<CheckBoxFieldProps> = (props) => {
  return (
    <FormField
      {...props}
      render={({ field }) => (
        <Checkbox
          name={props.name}
          defaultValue={props.defaultValue}
          listOption={props.options}
          onChange={e => field.onChange(e)}
        />
      )}
    />
  );
};